import { render, staticRenderFns } from "./StockTakingTab.vue?vue&type=template&id=3b27169a"
import script from "./StockTakingTab.vue?vue&type=script&lang=ts"
export * from "./StockTakingTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports